import { render, staticRenderFns } from "./Score_Reward.vue?vue&type=template&id=298312b9&scoped=true"
import script from "./Score_Reward.vue?vue&type=script&lang=js"
export * from "./Score_Reward.vue?vue&type=script&lang=js"
import style0 from "./Score_Reward.vue?vue&type=style&index=0&id=298312b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298312b9",
  null
  
)

export default component.exports